import React from 'react';
import { Link } from "react-router-dom";
import './footer.scss'

const Footer = () =>
{

	const handleSubmit = (e) =>
	{
		e.preventDefault();

		const formData = new FormData(e.target);

		fetch("https://docs.google.com/forms/d/e/1FAIpQLSfrS7GvvzP0uNzjiGfn9GQf1BXB0w0PPeZPtWcjNMlnx7_tdw/formResponse", {
			method: "POST",
			mode: "no-cors",
			body: formData,
		});

		alert("Submitted successfully!");
		e.target.reset();
	};

	return (
		<footer className="main-footer">
			<div className="footer-content-wrapper">
				<div className="footer-grid">
					<div className="brand-info">
						<div className="brand-name">Refresh Inn Touchwood</div>
						<p className="brand-description">
							Comfortable farm stays and home stays designed for relaxing and memorable experiences.
						</p>
						<p className="brand-description">
							Nikit Alagi  <a
								href="tel:+919049928292"
								className="agent-call"
							>
								📞 +91 9049928292
							</a>
						</p>
						{/* <div className="social-icons">
							<div className="icon-circle">
								<MdPublic className="material-symbols-outlined" />
							</div>
							<div className="icon-circle">
								<IoShareSocialOutline className="material-symbols-outlined" />
							</div>
						</div> */}
					</div>

					<div className="footer-column" >
						<h4 className="column-title">Navigation</h4>
						<ul className="footer-links">
							<li><Link to="/">Home</Link></li>
							<li><Link to="/farmstays">Farm Stays</Link></li>
							<li><Link to="/homestays">Home Stays</Link></li>
							{/*<li><a href="#">Contact</a></li>*/}
						</ul>
					</div>

					<div className="footer-column">
						<h4 className="column-title">Legal</h4>
						<ul className="footer-links">
							<li><Link to="/privacy-policy">Privacy Policy</Link></li>
							<li><Link to="/terms-and-service">Terms of Service</Link></li>
							{/*<li><Link to="#">Cookie Policy</Link></li>*/}
							{/*<li><Link to="#">Sitemap</Link></li>*/}
						</ul>
					</div>

					<div className="footer-column" id="contact-section">
						<h4 className="column-title">Contact us</h4>
						{/*<p className="newsletter-description">Get exclusive access to off-market properties.</p>*/}
						<form className="contact-form" onSubmit={handleSubmit}>
							<input name="entry.1595833940" type="text" placeholder="Name (optional)" />
							<input name="entry.790301452" type="email" placeholder="Email (optional)" />
							<input name="entry.1268155301" type="tel" placeholder="Phone Number *" required />
							<textarea name="entry.359586065" placeholder="Address (optional)" />

							<button type="submit">Submit</button>
						</form>
					</div>
				</div>

				<div className="footer-bottom">
					<p className="copyright">
						© 2026 Refresh Inn Touchwood. All rights reserved.
					</p>

					<div className="locations">
						<p>📍 Solapur, Maharashtra, India</p>
					</div>
				</div>

				<div className="footer-bottom-bottom">
					Designed & Developed by The A Team
				</div>
			</div>
		</footer>
	);
};

export default Footer;